import { render, staticRenderFns } from "./xianlin.vue?vue&type=template&id=072a50ba&"
import script from "./xianlin.vue?vue&type=script&lang=js&"
export * from "./xianlin.vue?vue&type=script&lang=js&"
import style0 from "./xianlin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports